import _ from 'underscore';
import { Point } from '../../../../../FrontendBundle/Resources/js/ofcs';
import CutangleItem from '../item/cutangleItem';
import LengthUnitField from './lengthUnitField';

/**
 * @class CutangleTopField
 */
export default class CutangleTopField extends LengthUnitField {
    type = 'cutangleTop';
    supports = 'supportsPositioning';
    handle = null;

    /**
     * Do nothing in this case
     */
    updateValue() {}

    /**
     * Update field with item value.
     *
     * @param {ItemInterface} item
     */
    updateItem(item) {
        const value = item.getParentItem().get('height') - this.getValue();
        const isStartPoint = this.handle.active.point === 'startPoint';

        const newPoint = isStartPoint
            ? new Point(item.get('line').startPoint.x, value)
            : new Point(item.get('line').endPoint.x, value);

        this.handle.projectPoint(this.handle.active.point, newPoint);
    }

    /**
     * Update item with field value and apply a difference.
     *
     * @param {ItemInterface} item
     * @param {number} difference
     */
    updateItemRelative(item, difference) {
        const value = item.getParentItem().get('height') - this.getValue(item, true);
        const isStartPoint = this.handle.active.point === 'startPoint';

        const newPoint = isStartPoint
            ? new Point(item.get('line').startPoint.x, value - difference)
            : new Point(item.get('line').endPoint.x, value - difference);

        this.handle.projectPoint(this.handle.active.point, newPoint);
    }

    /**
     * Do action.
     *
     * @param {CutangleItem} item
     */
    action(item) {
        this.hide();

        if (!item) return;

        const debouncedChangeVisibility = _.debounce((show) => {
            if (show) this.show();
            else this.hide();
        }, 250);

        item.on('activatePoint', (point, angle, handle) => {
            const isOnVerticalBorder = point.x === 0 || point.x === item.getParentItem().get('width');

            if (isOnVerticalBorder) {
                debouncedChangeVisibility(true);
                this.handle = handle;
                this.setValue(item.getParentItem().get('height') - point.y);
            } else {
                debouncedChangeVisibility(false);
            }
        });

        item.on('deactivatePoint', () => debouncedChangeVisibility(false));
    }

    /**
     * Check if field is supportet by item.
     *
     * @param {ItemInterface} item
     * @param {number} selectionLength
     *
     * @return {boolean}
     */
    isSupported(item, selectionLength) {
        return selectionLength === 1
            && item
            && item instanceof CutangleItem;
    }
}
